/* eslint-disable eqeqeq */
import axios from 'axios';
import CryptoJS from 'crypto-js';
import { api, failedApprove, failedReject, successReject, successApprove } from './constants';
import mutations from './mutations';
import state from './state';
import { postApi } from '../../../lib/fetcher';
import { atob, btoa } from '../../../lib/helpers';

export const ApprovalInterval = 5000;

const approvalRefund = {
  namespaced: true,
  state,
  mutations,
  actions: {
    async getData(ctx, { date, page, itemsPerPage, search }) {
      const URL_API = api.GET_LIST_APPROVAL_REFUND;

      if (ctx.state.requestData) ctx.state.requestData.cancel();

      const axiosSource = axios.CancelToken.source();

      ctx.commit('setCancelation', {
        cancel: axiosSource.cancel,
        msg: 'Loading...',
      });

      ctx.commit('clearData');
      ctx.commit('setLoading', true);
  

      const data = JSON.stringify({
        page: page.toString(),
        limit: itemsPerPage.toString(),
        search,
        sort_by: 'trx_datetime DESC',
        version: btoa(
          CryptoJS.SHA256(
            page.toString() +
              itemsPerPage.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const addConfig = { cancelToken: axiosSource.token };

      const responseData = await postApi(ctx, URL_API, data, addConfig);

      if (responseData?.code == 200) {
        ctx.commit('setTotalData', { payload: responseData });
        ctx.commit('setData', { payload: responseData });
      }
    },

    async getDetail(ctx, { date, id }) {
      const URL_API = api.GET_DETAIL_REQUEST_REFUND;

      ctx.commit('setLoading', true);

      const data = JSON.stringify({
        id,
        version: btoa(
          CryptoJS.SHA256(
            id + date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const responseData = await postApi(ctx, URL_API, data);

      if (responseData?.code == 200) {
        ctx.commit('setDataDetail', { payload: responseData });

        return responseData?.data;
      }

      return null;
    },
      

    async rejectRefund(ctx, { date, id, remark }) {
      const URL_API = api.SEND_REJECT_REFUND;

      ctx.commit('setShowProgressBar', true);
      ctx.commit('setLoading', true);
      ctx.commit('setPercentage', 0);
      ctx.commit('setProgressTitle', 'Processing Reject');
      ctx.commit('setProgressColor', 'green');

      const data = JSON.stringify({
        id,
        remark,
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const intervalId = setInterval(() => {
        const currentPercentage = ctx.state.percentage;

        if (currentPercentage < 80) {
          ctx.commit('setPercentage', currentPercentage + 1); 
        }
      }, 100);
      
      ctx.commit('setIntervalRefund', intervalId);

      try {
        const responseData = await postApi(ctx, URL_API, data);

        if (responseData?.code === 200) {
          clearInterval(intervalId); 
          successReject(ctx, responseData);

          return true;
        } 
        clearInterval(intervalId);
 
        return failedReject(ctx, responseData); 
    
      } catch (error) {
        clearInterval(intervalId);
 
        return failedReject(ctx)(); 
      } finally {
        clearInterval(ctx.state.intervalRefund);
        ctx.commit('setIntervalRefund', null);
        setTimeout(() => {
          ctx.commit('setLoading', false);
        }, 500); 
      }
    },

    async approveRefund(ctx, { date, id, remark }) {
      const URL_API = api.SEND_APPROVE_REFUND;

      ctx.commit('setShowProgressBar', true);
      ctx.commit('setLoading', true);
      ctx.commit('setPercentage', 0);
      ctx.commit('setProgressTitle', 'Processing Approval');
      ctx.commit('setProgressColor', 'green');

      const data = JSON.stringify({
        id,
        remark,
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });


      const intervalId = setInterval(() => {
        const currentPercentage = ctx.state.percentage;

        if (currentPercentage < 80) {
          ctx.commit('setPercentage', currentPercentage + 1); 
        }
      }, 100);
      
      ctx.commit('setIntervalRefund', intervalId);
      try {
        const responseData = await postApi(ctx, URL_API, data);

        if (responseData?.code === 200) {
          clearInterval(intervalId); 
          successApprove(ctx, responseData);

          return true;
        } 
        clearInterval(intervalId);
 
        return failedApprove(ctx, responseData); 
    
      } catch (error) {
        clearInterval(intervalId);
 
        return failedApprove(ctx); 
      } finally {
        clearInterval(ctx.state.intervalRefund);
        ctx.commit('setIntervalRefund', null);
        setTimeout(() => {
          ctx.commit('setLoading', false);
        }, 500); 
      }
    },

    closeProgressBar({ commit }) {
      commit('setShowProgressBar', false);
    },
  },
};

export default approvalRefund;
